import { TicketOrderIdSchema } from "./TicketOrder";
import { TicketDocumentSchema } from "./TicketDocument";
import { z } from "zod";

export const TicketOrderReceiptSchema = z.object({
  ticketOrderId: TicketOrderIdSchema,
  receiptPdf: z.string(),
  ticketDocuments: z.array(TicketDocumentSchema),
});

export type TicketOrderReceipt = z.infer<typeof TicketOrderReceiptSchema>;
